"use client";
import React from "react";
import AboutOverview from "@/components/about/AboutOverview";
import WhyUs from "@/components/about/WhyUs";
import Mision from "@/components/about/Mision";
import Directors from "@/components/about/Directors";
import AwardSlider from "@/components/about/AwardSlider";

const AboutSectionRenderer = ({ item, index }) => {
    switch (item?.section_data?.template) {
        case 'home_about_max':
            return (
                <React.Fragment key={index}>
                        <AboutOverview data={item} key={index}/>
                </React.Fragment>
            );
        case 'overview_box':
            return <WhyUs data={item} key={index}/>;
        case 'mission_vision_template':
            return  <Mision data={item} key={index}/>;
        case 'person_message':
            return <Directors data={item} key={index}/>;
        case 'award_slider':
            return <AwardSlider data={item} key={index}/>;
        default:
            return null; // If the template doesn't match any case, render nothing
    }
};

export default React.memo(AboutSectionRenderer);
